import { ElMessage } from 'element-plus'

export default {
    msg: (msg,type) => {
        ElMessage({
            message: msg,
            type: type,
        })
    }
}